import React from 'react';

import Input from './Input';

const InputString = (props) => (
    <Input {...props}></Input>
);

export default InputString;